// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SyncHouseholdsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.HouseholdWhereInput>;
  includeValidationStatus?: Types.Scalars['Boolean']['input'];
}>;


export type SyncHouseholdsQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: { __typename?: 'Household', id: string, displayName: string, private: boolean, hasPendingValidationQuestions?: boolean } | null } | null> | null } };

export const Operations = {
  Query: {
    SyncHouseholds: 'SyncHouseholds' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const SyncHouseholdsDocument = gql`
    query SyncHouseholds($where: HouseholdWhereInput, $includeValidationStatus: Boolean! = false) {
  households(where: $where) {
    edges {
      node {
        id
        displayName
        private
        hasPendingValidationQuestions @include(if: $includeValidationStatus)
      }
    }
  }
}
    `;

/**
 * __useSyncHouseholdsQuery__
 *
 * To run a query within a React component, call `useSyncHouseholdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncHouseholdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncHouseholdsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      includeValidationStatus: // value for 'includeValidationStatus'
 *   },
 * });
 */
export function useSyncHouseholdsQuery(baseOptions?: Apollo.QueryHookOptions<SyncHouseholdsQuery, SyncHouseholdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncHouseholdsQuery, SyncHouseholdsQueryVariables>(SyncHouseholdsDocument, withFetchPolicyContext(options));
      }
export function useSyncHouseholdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncHouseholdsQuery, SyncHouseholdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncHouseholdsQuery, SyncHouseholdsQueryVariables>(SyncHouseholdsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useSyncHouseholdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SyncHouseholdsQuery, SyncHouseholdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SyncHouseholdsQuery, SyncHouseholdsQueryVariables>(SyncHouseholdsDocument, withFetchPolicyContext(options));
        }
export type SyncHouseholdsQueryHookResult = ReturnType<typeof useSyncHouseholdsQuery>;
export type SyncHouseholdsLazyQueryHookResult = ReturnType<typeof useSyncHouseholdsLazyQuery>;
export type SyncHouseholdsSuspenseQueryHookResult = ReturnType<typeof useSyncHouseholdsSuspenseQuery>;
export type SyncHouseholdsQueryResult = Apollo.QueryResult<SyncHouseholdsQuery, SyncHouseholdsQueryVariables>;